// extracted by mini-css-extract-plugin
export default {"formContainer":"Signup_formContainer__HyGmf","title":"Signup_title__M+5Uv","error":"Signup_error__kcSu1"};